import React from "react"
import Img from "gatsby-image"

const SuitableFor = ({ data }) => {
  return (
    <React.Fragment>
      <div className="container mx-auto my-5">
        <h2 className="text-center">Suitable For</h2>
        <div className="row mt-5">
          {data.map(suitableFor => {
            return (
              <div
                key={suitableFor.node.id}
                className="mt-5 mt-md-5 mt-lg-1 col-10 col-sm-10 col-md-6 col-lg-3 mx-auto d-flex flex-column align-item-center"
              >
                <Img
                  className="mx-auto rounded-circle"
                  fixed={
                    suitableFor.node.featured_media.localFile.childImageSharp
                      .fixed
                  }
                />
                <h6 className="mt-3 text-center text-muted">
                  {suitableFor.node.title}
                </h6>
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default SuitableFor
